export const SEMANTIC_LOCK_ICON = 'lock';
export const SEMANTIC_UNLOCK_ICON = 'unlock';
export const PARSING_ERROR_MESSAGE = '*Parsing Error*';
